<ng-container
  main
  *ngIf="viguideRecommendationsStore.isAnyOptimizationRecommendationAvailable$ | async"
>
  <app-banner
    [title]="'+INSTALLATIONS.NOTIFICATIONS.OPTIMIZATION.TITLE' | translate"
    [linkLabel]="'+INSTALLATIONS.NOTIFICATIONS.OPTIMIZATION.NAVIGATE' | translate"
    (clickEvent)="optimizationBannerService.openOptimizationOverlay()"
    linkGtm="onOptimizationOverlayOpen"
  >
    {{ '+INSTALLATIONS.NOTIFICATIONS.OPTIMIZATION.MESSAGE' | translate }}
  </app-banner>
</ng-container>
